import { Box, Button, Grid2, Typography } from "@mui/material";
// SVG png import
import Loginlogo from "../../assets/images/tharagreen-logo-green.svg";
import Accessdeniedimg from "../../assets/images/accessdenied-head-img.png";
import Appstoreimg from "../../assets/images/appstore-img.png";
import Playstoreimg from "../../assets/images/playstore-img.png";

// Multilingual support
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

// Access Denied component
const AccessDenied: React.FC = () => {
  const navigate = useNavigate();

  // Clear session and navigate user to login screen
  const goBack = () => {
    localStorage.clear();
    navigate("/authenticate");
  };
  return (
    <>
      <Box className="login-outer">
        <video className="background-video" autoPlay loop muted playsInline>
          <source
            src={require("../../assets/videos/agriBackground.mp4")}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>

        <Box sx={{ flexGrow: 1 }}>
          <Grid2
            container
            spacing={5}
            gap={2}
            className="full-height-grid hv-center"
          >
            <Grid2 size={6}>
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Box
                  className="login-wrapper"
                  sx={{
                    bgcolor: "primary.contrastText",
                    p: 6,
                    borderRadius: 5,
                    boxShadow: 3,
                  }}
                >
                  <Box
                    component="img"
                    src={Loginlogo}
                    alt="Thara Green"
                    sx={{
                      margin: "auto",
                      display: "flex",
                      width: 86,
                      height: 110,
                    }}
                  />
                  <Box>
                    <img
                      src={Accessdeniedimg}
                      style={{
                        margin: "auto",
                        display: "flex",
                        width: 135,
                        height: 160,
                        marginTop: "24px",
                        marginBottom: "24px",
                      }}
                    />
                    <Typography
                      fontWeight={600}
                      align="center"
                      fontSize={16}
                      sx={{
                        color: "risinblack.main",
                      }}
                    >
                      {t("accessDenied.accessDeniedInfo")}
                    </Typography>
                    <Box display={"flex"} gap={3} marginY={3}>
                      <Button
                        fullWidth
                        variant="outlined"
                        sx={{
                          borderColor: "risinblack.main",
                        }}
                      >
                        <img
                          src={Appstoreimg}
                          style={{
                            margin: "auto",
                            display: "flex",
                            width: "auto",
                            height: 30,
                          }}
                        />
                      </Button>
                      <Button
                        fullWidth
                        variant="outlined"
                        sx={{
                          borderColor: "risinblack.main",
                        }}
                      >
                        <img
                          src={Playstoreimg}
                          style={{
                            margin: "auto",
                            display: "flex",
                            width: "auto",
                            height: 30,
                          }}
                        />
                      </Button>
                    </Box>
                    <Button
                      type="submit"
                      variant="outlined"
                      size="large"
                      fullWidth
                      sx={{
                        marginTop: 1,
                        marginBottom: 1,
                        padding: 1,
                        color: "risinblack.main",
                        borderColor: "risinblack.main",
                      }}
                      onClick={(event) => {
                        goBack();
                      }}
                    >
                      Back
                      {/* {t("login.submit")} */}
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={6}>
              <Box
                className="login-quote"
                sx={{ fontStyle: "italic", marginLeft: 15, letterSpacing: 1 }}
              >
                {t("authManager.slogan")}
              </Box>
              <Box
                className="login-quote"
                sx={{
                  marginLeft: 15,
                  textAlign: "right",
                  marginTop: 2,
                  letterSpacing: 1,
                }}
              >
                {t("authManager.name")}
              </Box>
            </Grid2>
          </Grid2>
        </Box>
      </Box>
    </>
  );
};

export default AccessDenied;
